<template>
  <div class="quest-index">
    <!-- 抬头 -->
    <div class="head">
      <div class="head-left">
        <h4>问卷管理</h4>
      </div>
      <div class="head-right">
        <div class="inputBox">
          <el-input
            :clearable="true"
            placeholder="输入问卷名称"
            v-model="questionnairesInput"
            clearable
            @change="change"
          >
          </el-input>
          <el-button
            size="medium"
            style="background: #484c7f; color: #fff"
            @click="searchPreview"
          >搜索</el-button>
        </div>
        <div class="head-right-btn">
          <el-button
            size="medium"
            style="background: #258ce8; color: #fff"
            @click="previewCreate"
          >+创建问卷</el-button>
        </div>
      </div>
    </div>
    <!-- 抬头结束 -->
    <!-- 内容 -->
    <div class="quest-contents">
      <div
        v-show="questionnairesObject.list==0"
        class="available"
      >当前页面无数据</div>
      <div class="quest-contents-box">
        <ul class="quest-contents-box-ul">
          <transition-group
            name="quest-delete"
            tag="ul"
          >
            <li
              class="quest-contents-box-item"
              v-for="(item,index) in questionnairesObject.list"
              :key="item.id"
              @click="questionnairesDetails(item,index)"
            >
              <div class="quest-contents-box-item-box">
                <!-- 左侧 -->
                <div class="quest-contents-box-item-left">
                  <div class="quest-contents-box-item-left-text">
                    <div class="quest-contents-box-item-left-text-img">
                      <img
                        src="../../assets/image/questionnaires/11document.png"
                      >
                    </div>
                    <div class="quest-contents-box-item-left-text-name">
                      {{item.survey_name}}</div>
                  </div>
                  <div class="quest-contents-box-item-left-time">
                    <div class="quest-contents-box-item-left-time-date">
                      {{item.created_at}}
                    </div>
                    <!-- <div class="quest-contents-box-item-left-time-specific">
                      {{item.time_t}}
                    </div> -->
                  </div>
                </div>
                <!-- 左侧 结束-->
                <!-- 右侧 -->
                <div class="quest-contents-box-item-right">
                  <ul class="quest-contents-box-item-right-ul">
                    <li
                      class="quest-contents-box-item-right-item"
                      @click.stop="sendQuestionnaire(item,index)"
                    >
                      <span>
                        <img src="../../assets/image/questionnaires/1_发送.png">
                      </span>
                      <div>发送问卷</div>
                    </li>
                    <!-- <li
                      class="quest-contents-box-item-right-item"
                      @click.stop="editorQuestionnaire(item,index)"
                    >
                      <span>
                        <img src="../../assets/image/questionnaires/组 637.png">
                      </span>
                      <div>编辑</div>
                    </li> -->
                    <li
                      class="quest-contents-box-item-right-item"
                      @click.stop="checkQuestionnaire(item,index)"
                    >
                      <span>
                        <img src="../../assets/image/questionnaires/查看.png">
                      </span>
                      <div>查看问卷</div>
                    </li>
                    <li
                      class="quest-contents-box-item-right-item"
                      @click.stop="deleteQuestionnaire(item,index)"
                    >
                      <span>
                        <img src="../../assets/image/questionnaires/医疗_删除.png">
                      </span>
                      <div>删除</div>
                    </li>
                  </ul>
                </div>
                <!-- 右侧 结束 -->
              </div>
            </li>
          </transition-group>
        </ul>
      </div>
    </div>
    <!-- 内容 结束 -->
    <!-- 分页 -->
    <div
      class="page"
      v-show="questionnairesObject.list!=0"
    >
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentchange"
        @prev-click="prevClick"
        @next-click="nextClick"
        :page-count="questionnairesObject.pages"
        :current-page.sync="currentPage"
      >
      </el-pagination>
    </div>
    <!-- 分页 -->
    <!-- 分享弹窗 -->
    <el-dialog
      title="分享问卷"
      :visible.sync="centerDialogVisible"
      width="27.5%"
      center
    >
      <div class="dialog-box">
        <div class="dialog-heda">
          <div class="dialog-heda-img">
            <img src="../../assets/image/questionnaires/蒙版组 132.png">
          </div>
          <div class="dialog-heda-text">
            {{dialogItme.survey_name}}
          </div>
        </div>
        <div class="dialog-share">
          <div class="dialog-share-fxz">分享至</div>
          <div class="dialog-share-box">
            <!-- 微信 -->
            <div
              class="dialog-share-box-wx"
              @click="dialogShareWX"
            >
              <div class="dialog-share-box-img">
                <div class="dialog-share-box-img-wx">
                  <img src="../../assets/image/questionnaires/微信 (3).png">
                </div>
              </div>
              <div class="dialog-share-box-text">微信好友</div>
            </div>
            <!-- 微信结束 -->
            <!-- 链接 -->
            <div
              class="dialog-share-box-lj"
              @click="dialogShareLJ"
            >
              <div class="dialog-share-box-img">
                <div class="dialog-share-box-img-fx">
                  <img src="../../assets/image/questionnaires/链接 (1).png">
                </div>
              </div>
              <div class="dialog-share-box-text">复制链接</div>
            </div>
            <!-- 链接结束 -->
          </div>
        </div>
        <div class="dialog-bgc">
          <img src="../../assets/image/questionnaires/蒙版组 131.png">
        </div>
      </div>
    </el-dialog>
    <!-- 分享弹窗 -->
    <!-- 微信扫码 弹窗 -->
    <el-dialog
      title="分享微信好友"
      :visible.sync="centerDialogVisibleWX"
      width="27.5%"
      center
    >
      <div class="dialog-box-wx">
        <div class="dialog-box-wx-img-box">
          <div class="dialog-box-wx-img">
            <!-- <img src="../../assets/image/questionnaires/下载.png"> -->
            <el-row
              type="flex"
              justify="center"
            >
              <canvas ref="myCanvas" />
            </el-row>
          </div>
        </div>
        <div class="dialog-box-wx-text">
          <p>打开手机微信“扫一扫”，分享给好友</p>
        </div>
        <div class="dialog-bgc-wx">
          <img src="../../assets/image/questionnaires/蒙版组 131.png">
        </div>
      </div>
    </el-dialog>
    <!-- 微信扫码 弹窗 -->
  </div>
</template>
 
<script>
import QrCode from 'qrcode' //二维码生成 
export default {
  name: 'questionnaires',
  data () {
    return {
      questionnairesInput: '',
      questionnairesObject: {
        pages: 8,
        list: [
          {
            name: '2022DDW精粹 | 同排序生物制剂治疗对IBD治疗结局影响如何？这项真实世界研究给出了答案同排序生物制剂治疗对IBD治疗结局影响如何？这项真实世界研究给出了答案不同排序生物制剂治疗对IBD治疗结局影响如何？这项真实世界研究给出了答案！循环界学分领取者基本信息2022DDW精粹 | 不同排序生物制这项真实世界研究给出了答案！循环界学分领取者基本信息',
            time: "2022-07-01",
            time_t: '16:45'
          },
          {
            name: '神经界学分领取处的基本信息',
            time: "2022-07-01",
            time_t: '16:45'
          },
          {
            name: '27岁女子胃疼、黑便拒绝检查，直到体重骤减，诊断结果医生直叹可惜',
            time: "2022-07-01",
            time_t: '16:45'
          },
          {
            name: '“网红”饮食法再登顶刊！Nature首度揭露：「间歇性禁食」竟可促进神经再生和修复',
            time: "2022-07-01",
            time_t: '16:45'
          },
        ]
      },
      total: 0,//总条目数
      pagesize: 8,//每页显示条目个数
      currentPage: 1,//当前页数
      centerDialogVisible: false,//弹窗
      centerDialogVisibleWX: false,//微信弹窗
      dialogItme: {}
    }
  },
  activated () {
    this.getQuestionnaireDetailsLsit()
  },
  //keep-alive 停用触发
  deactivated () {
    this.questionnairesInput = ''
    this.getQuestionnaireDetailsLsit()
  },
  methods: {
    //获取列表
    async getQuestionnaireDetailsLsit () {
      const { data: data } = await this.$http.post('survery/list', {
        page: this.currentPage,
        limit: this.pagesize,
        title: this.questionnairesInput,
      })
      this.questionnairesObject = data.data
      this.$Spin.hide();
    },
    //抬头创建问卷调查 
    previewCreate () {
      this.$router.push('/questionnaires/create')
    },
    //问卷详情 
    questionnairesDetails (item, index) {
      this.$router.push({
        path: '/questionnaires/questionnaireDetails',
        query: {
          id: item.id
        }
      })
    },
    //发送问卷
    sendQuestionnaire (item, index) {
      this.getSendQuestionnaireApi(item.id)
      this.centerDialogVisible = true
    },
    //发送问卷APi
    async getSendQuestionnaireApi (id) {
      const { data: data } = await this.$http.post('survery/send', {
        id,
      })
      this.dialogItme = data.data
    },
    //分享微信
    dialogShareWX () {
      this.centerDialogVisibleWX = true
      this.WXQrCode(this.dialogItme.wechat.short_url)
    },
    //微信合成二维码
    WXQrCode (url) {
      if (!url) return
      this.showCodeDialog = true
      this.$nextTick(() => {
        QrCode.toCanvas(this.$refs.myCanvas, url)
      })
    },
    //分享链接 
    dialogShareLJ () {
      this.getReproduction(this.dialogItme.pc.short_url)
    },
    //复制链接
    getReproduction (data) {
      let input = document.createElement("input");// js创建一个input(textarea)输入框   
      input.value = data
      document.body.appendChild(input);//将输入框暂时创建到实例里面
      input.select();   // 选中输入框中的内容
      document.execCommand("Copy");    //执行复制操作
      document.body.removeChild(input) //最后删除实例中临时创建的input输入框，完成复制操作
      this.$message({
        message: '复制成功',
        type: 'success'
      });
      setTimeout(() => {
        this.centerDialogVisible = false
      }, 500)
    },
    //查看问卷(查看谁填写) 
    checkQuestionnaire (item, index) {
      this.$router.push({
        path: '/questionnaires/check',
        query: {
          id: item.id
        }
      })
    },
    //删除问卷  
    deleteQuestionnaire (item, index) {
      this.$confirm('您是否要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('survery/delete', { id: item.id })
        this.getQuestionnaireDetailsLsit()
        this.$message({
          message: data.message,
          type: 'success'
        });
      }).catch(() => { })
    },
    //抬头回车 
    change (value) {
      this.questionnairesInput = value
      this.currentPage = 1
      setTimeout(() => {
        this.getQuestionnaireDetailsLsit()
      }, 500)
      this.$Spin.show();
    },
    //抬头搜索按钮    
    searchPreview () {
      this.currentPage = 1
      setTimeout(() => {
        this.getQuestionnaireDetailsLsit()
      }, 500)
      this.$Spin.show();
    },
    //点击每一页 
    currentchange (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getQuestionnaireDetailsLsit()
      }, 500)
      this.$Spin.show();
    },
    //上一页  
    prevClick (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getQuestionnaireDetailsLsit()
      }, 500)
      this.$Spin.show();
    },
    //下一页
    nextClick (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getQuestionnaireDetailsLsit()
      }, 500)
      this.$Spin.show();
    },
  }
}

</script> 
<style lang="less" scoped>
.quest-index {
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    .head-left {
      h4 {
        font-size: 28px;
        color: #212529;
      }
    }
    .head-right {
      display: flex;
      .head-right-btn {
        margin-left: 167px;
      }
      .inputBox {
        flex: 1;
        display: flex;
        /deep/.el-input {
          width: 332px;
          flex: 1;
          margin-right: 16px;
        }
      }
    }
  }

  .quest-contents {
    padding: 45px 30px 50px 30px;
    width: 100%;
    min-height: 645px;
    // box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.1);
    box-shadow: rgba(100, 100, 111, 0.15) 0px 7px 29px 0px;
    border-radius: 8px;

    .quest-contents-box {
      .quest-contents-box-ul {
        .quest-contents-box-item {
          cursor: pointer;
          overflow: hidden;
          transition: all 0.6s;
          padding: 25px;
          border-radius: 15px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 0px 10px #d0d3fb;
          margin-bottom: 38px;
          &:last-child {
            margin-bottom: 0;
          }
          .quest-contents-box-item-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            //左
            .quest-contents-box-item-left {
              width: 835px;
              .quest-contents-box-item-left-text {
                display: flex;
                .quest-contents-box-item-left-text-img {
                  width: 22px;
                  height: 22px;
                  img {
                    width: 100%;
                    height: 100%;
                  }
                }
                .quest-contents-box-item-left-text-name {
                  flex: 1;
                  margin: 0 0 22px 13px;
                  font-size: 16px;
                  color: #212529;
                }
              }

              .quest-contents-box-item-left-time {
                display: flex;
                align-items: center;
                color: #c7c7c7;
                font-size: 14px;
                .quest-contents-box-item-left-time-date {
                }
                .quest-contents-box-item-left-time-specific {
                  margin-left: 10px;
                }
              }
            }
            //右
            .quest-contents-box-item-right {
              .quest-contents-box-item-right-ul {
                display: flex;
                justify-content: center;
                align-items: center;
                .quest-contents-box-item-right-item {
                  cursor: pointer;
                  margin-left: 35px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  span {
                    width: 19.5px;
                    height: 19.5px;
                    img {
                      width: 100%;
                      height: 100%;
                    }
                  }
                  div {
                    margin-left: 7px;
                    color: #212529;
                    font-size: 14px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .page {
    margin-top: 30px;
    text-align: right;
  }
  .available {
    text-align: center;
    color: #8588ae;
    margin: 0 auto;
    padding-top: 280px;
  }

  /deep/ .el-dialog__header {
    display: flex;
    justify-content: unset;
  }

  /deep/ .el-dialog__title {
    color: #212529;
    font-weight: 800;
  }

  /deep/ .el-dialog {
    border-radius: 10px;
  }

  .dialog-box {
    position: relative;
    .dialog-heda {
      display: flex;
      align-items: center;
      padding-bottom: 30px;
      border-bottom: 1px solid #f6f6f6;
      .dialog-heda-img {
        width: 144px;
        height: 133px;
        margin-right: 40px;
      }
      .dialog-heda-text {
        font-size: 13px;
        color: #2d2d2d;
      }
    }
    .dialog-share {
      margin-top: 22px;
      .dialog-share-fxz {
        font-size: 15px;
        color: #2d2d2d;
        margin-bottom: 22px;
      }
      .dialog-share-box {
        position: relative;
        z-index: 999;
        display: flex;
        align-items: center;
        .dialog-share-box-wx {
          cursor: pointer;
          margin-right: 35px;
        }
        .dialog-share-box-lj {
          cursor: pointer;
        }
        .dialog-share-box-img {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 52px;
          height: 52px;
          background-color: #eeeeee;
          border-radius: 4px;
        }
        .dialog-share-box-text {
          font-size: 13px;
          color: #898989;
          margin-top: 5px;
        }

        .dialog-share-box-img-fx {
          width: 19px;
          height: 19px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .dialog-share-box-img-wx {
          width: 24px;
          height: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .dialog-bgc {
    z-index: 1;
    position: absolute;
    bottom: -30px;
    left: -5px;
    width: 517px;
    height: 129px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .dialog-box-wx {
    position: relative;
    .dialog-box-wx-img-box {
      display: flex;
      justify-content: center;
      align-items: center;
      .dialog-box-wx-img {
        margin: 50px 0 35px 0;
        width: 146px;
        height: 146px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .dialog-box-wx-text {
      position: relative;
      font-size: 14px;
      color: #2d2d2d;
      z-index: 22;
      text-align: center;
      padding-bottom: 47px;
    }

    .dialog-bgc-wx {
      z-index: 1;
      position: absolute;
      bottom: -30px;
      left: -5px;
      width: 517px;
      height: 129px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  //进入
  .quest-delete-enter-active {
    //animation: rotate-in-center 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }

  @keyframes rotate-in-center {
    0% {
      transform: rotate(-360deg);
      opacity: 0;
    }
    100% {
      transform: rotate(0);
      opacity: 1;
    }
  }

  //离开
  .quest-delete-leave-active {
    position: absolute;
    animation: scale-out-center 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  }
  .quest-delete-enter-to {
    transform: scale(1);
  }
  @keyframes scale-out-center {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0);
      opacity: 0;
    }
  }
}
</style>   